import React, { useRef } from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Stack,
  Textarea,
  Tooltip,
  useClipboard,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import emailjs from '@emailjs/browser';
import { BsInstagram, BsLinkedin, BsPerson, BsFacebook } from 'react-icons/bs';
import { MdEmail, MdOutlineEmail } from 'react-icons/md';
import FlagBG from './images/flag2.png';

export default function Contact() {
  const { hasCopied, onCopy } = useClipboard('festinobeats12@abesit.edu.in');

  // const userValues = {
  //   fullName: '',
  //   email: '',
  //   contact: '',
  //   message: ''
  // };
  // const [values, setValues] = useState(userValues);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setValues({
  //     ...values,
  //     [name]: value,
  //   });
  // };

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_s9awzc8', 'template_n5smrap', form.current, 'Tuc2NX3NfMucYgHuv')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
    form.current.reset()
  };

  return (
    <Flex
      align="center"
      justify="center"
      css={{
        backgroundImage: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%,rgba(0,0,0,0.2) 100%), url(' + FlagBG + ')',
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
      id="contact">
      <Box
        borderRadius="lg"
        m={{ base: 8, md: 10, lg: 10 }}
        p={{ base: 5, lg: 10 }}>
        <Box>
          <VStack spacing={{ base: 4, md: 8, lg: 10 }} >
            <Heading
              fontSize={{
                base: '4xl',
                md: '5xl',
              }}>
              Get in Touch with Us !!
            </Heading>

            <Stack
              spacing={{ base: 4, md: 8, lg: 10 }}
              direction={{ base: 'column', md: 'column' }}>
              <Stack
                align="center"
                justify="space-around"
                direction={{ base: 'row', md: 'row' }}>
                <Tooltip
                  label={hasCopied ? 'Email Copied!' : 'Copy Email'}
                  closeOnClick={false}
                  hasArrow>
                  <IconButton
                    aria-label="email"
                    variant="ghost"
                    size="lg"
                    fontSize="3xl"
                    icon={<MdEmail />}
                    _hover={{
                      bg: 'yellow.500',
                      color: useColorModeValue('white', 'gray.700'),
                    }}
                    onClick={onCopy}
                    isRound
                  />
                </Tooltip>

                <Link href="https://www.instagram.com/abesit_ghaziabad/" target="_blank">
                  <IconButton
                    aria-label="instagram"
                    variant="ghost"
                    size="lg"
                    fontSize="3xl"
                    icon={<BsInstagram />}
                    _hover={{
                      bg: 'pink.500',
                      color: useColorModeValue('white', 'gray.700'),
                    }}
                    isRound
                  />
                </Link>

                <Link href="https://www.facebook.com/abesit.in" target="_blank">
                  <IconButton
                    aria-label="facebook"
                    variant="ghost"
                    size="lg"
                    icon={<BsFacebook size="28px" />}
                    _hover={{
                      bg: 'blue.500',
                      color: useColorModeValue('white', 'gray.700'),
                    }}
                    isRound
                  />
                </Link>

                <Link href="https://www.linkedin.com/school/abesit-college-of-engineering/" target="_blank">
                  <IconButton
                    aria-label="linkedin"
                    variant="ghost"
                    size="lg"
                    icon={<BsLinkedin size="28px" />}
                    _hover={{
                      bg: 'blue.500',
                      color: useColorModeValue('white', 'gray.700'),
                    }}
                    isRound
                  />
                </Link>
              </Stack>
              <form className='contactForm' ref={form} onSubmit={sendEmail}>
                <Box
                  bg={useColorModeValue('white', 'gray.700')}
                  width={{ base: '270px', sm: '270px', md: '450px', lg: '450px' }}
                  borderRadius="lg"
                  p={8}
                  color={useColorModeValue('gray.700', 'whiteAlpha.900')}
                  shadow="base">
                  <VStack spacing={5} >
                    <FormControl isRequired>
                      <FormLabel>Name</FormLabel>

                      <InputGroup>
                        <InputLeftElement children={<BsPerson />} />
                        <Input
                          type="text"
                          name="user_name"
                          placeholder="Your Name"
                        // value={values.fullName}
                        // onChange={handleChange} 
                        />
                      </InputGroup>
                    </FormControl>
                    <FormControl isRequired>
                      <FormLabel>Phone</FormLabel>

                      <InputGroup>
                        <InputLeftElement children={<BsPerson />} />
                        <Input
                          type="number"
                          name="user_contact"
                          placeholder="Your Number"
                        // value={values.contact}
                        // onChange={handleChange} 
                        />
                      </InputGroup>
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>Email</FormLabel>

                      <InputGroup>
                        <InputLeftElement children={<MdOutlineEmail />} />
                        <Input
                          type="email"
                          name="user_email"
                          placeholder="Your Email"
                        // value={values.email}
                        // onChange={handleChange}
                        />
                      </InputGroup>
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>Message</FormLabel>

                      <Textarea
                        name="message"
                        placeholder="Your Message"
                        rows={6}
                        resize="none"
                      // value={values.message}
                      // onChange={handleChange}
                      />
                    </FormControl>

                    <Button
                      colorScheme="blue"
                      bg="blue.400"
                      color="white"
                      _hover={{
                        bg: 'blue.500',
                      }}
                      // onClick={sendEmail}
                      type="submit"
                      // value="Send"
                    >
                      Send Message
                    </Button>
                  </VStack>
                </Box>
              </form>
            </Stack>
          </VStack>
        </Box>
      </Box>
    </Flex>
  );
}
